export default {"src":"/_next/static/media/img-price-test-service.2eed9d98.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};